import { useState, useRef, useCallback, useEffect } from 'react'

const useScrollbarVisibility = (watchValues: unknown[]) => {
  const [isScrollbarVisible, setIsScrollbarVisible] = useState(false)
  const scrollContainerRef = useRef<HTMLDivElement | null>(null)

  const updateScrollbarVisibility = useCallback(() => {
    const container = scrollContainerRef.current
    if (!container) {
      setIsScrollbarVisible(false)
      return
    }
    setIsScrollbarVisible(container.scrollHeight > container.clientHeight)
  }, [])

  useEffect(() => {
    updateScrollbarVisibility()
    const container = scrollContainerRef.current
    if (!container) return

    const resizeObserver = new ResizeObserver(updateScrollbarVisibility)
    resizeObserver.observe(container)

    return () => {
      resizeObserver.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateScrollbarVisibility, ...watchValues])

  return { isScrollbarVisible, scrollContainerRef }
}

export default useScrollbarVisibility
